<script setup>
// "How it works" trigger + dialog for a format explainer carousel. Two trigger
// styles: 'strip' renders an `.as` button for the member pages' tl-action-strip
// (InformationDialog's pattern); 'none' renders no trigger — the parent opens
// it via v-model (used by the admin dashboard format cards).
import {ref, computed, watch} from 'vue';
import TlDialog from '~/components/TlDialog.vue';
import FormatExplainerCarousel from '~/components/formats/FormatExplainerCarousel.vue';
import {formatExplainers} from '~/utils/formatExplainers';

const props = defineProps({
  // 'league' | 'americano' | 'ladder' | 'tournament' | 'meet'
  format: {type: String, required: true},
  // Admin viewers get EVERY step (member + organiser); members just theirs.
  admin: {type: Boolean, default: false},
  // 'strip' (an .as button) | 'none' (parent-controlled via v-model)
  trigger: {type: String, default: 'strip'},
  modelValue: {type: Boolean, default: false},
  // false = no entry-fee / billing slides (free competition or club without payments).
  payments: {type: Boolean, default: true},
});
const emit = defineEmits(['update:modelValue']);

const open = ref(props.modelValue);
watch(() => props.modelValue, v => (open.value = v));
watch(open, v => emit('update:modelValue', v));

const title = computed(() => {
  const format = formatExplainers[props.format];
  return format ? `How ${format.name.toLowerCase()} work` : 'How it works';
});
</script>

<template>
  <button v-if="trigger === 'strip'" type="button" class="as" @click="open = true">
    <v-icon size="17">mdi-school-outline</v-icon>
    How it works
  </button>
  <tl-dialog v-model="open" :title="title" :max-width="520">
    <format-explainer-carousel :format="format" :audience="admin ? 'all' : 'players'" :payments="payments"/>
  </tl-dialog>
</template>
